/* Pyjama Cinematic — storefront behavior (native Shopify OS 2.0).
   Drawers, cart AJAX, Quick-Select popup, product variants + gallery, predictive search,
   announcement marquee, favorites, fly-to-cart. Ported from the prototype's interactions. */
(function () {
  'use strict';
  var T = window.theme || {};
  var routes = T.routes || {};
  var S = (T.strings || {});
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------------- money ---------------- */
  function formatMoney(cents) {
    var fmt = T.moneyFormat || '${{amount}}';
    function fmtNum(n) {
      n = (n / 100).toFixed(2);
      var p = n.split('.');
      return p[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1,') + '.' + p[1];
    }
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/g, fmtNum(cents));
  }

  /* ---------------- toast ---------------- */
  var toastT;
  function toast(msg) {
    var el = $('#mp-toast'); if (!el) return;
    el.textContent = msg; el.classList.add('is-visible');
    clearTimeout(toastT); toastT = setTimeout(function () { el.classList.remove('is-visible'); }, 2200);
  }

  /* ---------------- drawers + scrim ---------------- */
  var scrim = null;
  function ensureScrim() { scrim = scrim || $('[data-scrim]'); return scrim; }
  function openDrawer(el, kind) {
    if (!el) return;
    if (kind === 'cart') el.style.transform = 'translateX(0)';
    else if (kind === 'search') { el.style.opacity = '1'; el.style.visibility = 'visible'; el.style.transform = 'translate(-50%,0)'; el.style.pointerEvents = 'auto'; }
    else if (kind === 'menu') { el.style.opacity = '1'; el.style.visibility = 'visible'; el.style.transform = 'translateY(0) scale(1)'; el.style.pointerEvents = 'auto'; }
    var sc = ensureScrim(); if (sc && kind !== 'menu') sc.classList.add('is-open');
    document.body.classList.add('mp-no-scroll');
  }
  function closeAll() {
    var cd = $('[data-cart-drawer]'); if (cd) cd.style.transform = 'translateX(100%)';
    var sd = $('[data-search-drawer]'); if (sd) { sd.style.opacity = '0'; sd.style.visibility = 'hidden'; sd.style.transform = 'translate(-50%,-18px)'; sd.style.pointerEvents = 'none'; }
    var mn = $('[data-menu]'); if (mn) { mn.style.opacity = '0'; mn.style.visibility = 'hidden'; mn.style.transform = 'translateY(-10px) scale(.98)'; mn.style.pointerEvents = 'none'; }
    var sc = ensureScrim(); if (sc) sc.classList.remove('is-open');
    document.body.classList.remove('mp-no-scroll');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); refreshCart().then(function () { openDrawer($('[data-cart-drawer]'), 'cart'); }); }
    else if (e.target.closest('[data-open-search]')) { e.preventDefault(); openDrawer($('[data-search-drawer]'), 'search'); var si = $('[data-search-input]'); if (si) setTimeout(function () { si.focus(); }, 60); }
    else if (e.target.closest('[data-open-menu]')) { e.preventDefault(); var mn = $('[data-menu]'); if (mn && mn.style.visibility === 'visible') closeAll(); else openDrawer(mn, 'menu'); }
    else if (e.target.closest('[data-cart-close]') || e.target.closest('[data-search-close]') || e.target.closest('[data-quick-close]') || e.target.closest('[data-scrim]')) { e.preventDefault(); closeAll(); closeQuick(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); closeQuick(); } });

  /* ---------------- cart AJAX ---------------- */
  function cartGet() { return fetch(routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function cartAdd(id, qty) {
    return fetch(routes.cart_add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: qty || 1 }) }).then(function (r) { return r.json(); });
  }
  function cartChange(line, qty) {
    return fetch(routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) }).then(function (r) { return r.json(); });
  }
  function renderCartBody(cart) {
    var html = '';
    if (!cart.items || !cart.items.length) {
      html = '<div style="text-align:center;color:rgba(233,226,255,.5);font-family:\'Jost\',sans-serif;font-weight:300;padding:40px 10px;">' + escapeHtml(S.emptyCart || 'Your bag is empty.') + '</div>';
    } else {
      cart.items.forEach(function (it, i) {
        var line = i + 1;
        var img = it.image ? '<img src="' + escapeHtml(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) + '" alt="" width="66" height="99" style="width:100%;height:100%;object-fit:cover;">' : '';
        var vt = (!it.product_has_only_default_variant) ? '<div style="font-family:\'Jost\',sans-serif;font-weight:300;font-size:12px;color:rgba(233,226,255,.55);margin-top:3px;">' + escapeHtml(it.variant_title) + '</div>' : '';
        html += '<div data-cart-item data-key="' + escapeHtml(it.key) + '" data-line="' + line + '" style="display:flex;gap:14px;padding:14px 0;border-bottom:1px solid rgba(160,120,255,.12);">' +
          '<a href="' + escapeHtml(it.url) + '" style="width:66px;height:99px;flex-shrink:0;border-radius:10px;overflow:hidden;background:rgba(120,80,210,.15);">' + img + '</a>' +
          '<div style="flex:1;min-width:0;"><a href="' + escapeHtml(it.url) + '" style="font-family:\'Cormorant Garamond\',serif;font-size:19px;color:#f4f1fc;text-decoration:none;line-height:1.1;">' + escapeHtml(it.product_title) + '</a>' + vt +
          '<div style="display:flex;align-items:center;gap:10px;margin-top:10px;"><div style="display:flex;align-items:center;gap:2px;border:1px solid rgba(160,120,255,.24);border-radius:9px;overflow:hidden;">' +
          '<button type="button" data-cart-dec="' + line + '" style="width:30px;height:30px;background:rgba(255,255,255,.02);border:none;color:#e9e2ff;cursor:pointer;">&minus;</button>' +
          '<span style="width:32px;text-align:center;font-family:\'Jost\',sans-serif;font-size:13px;color:#f4f1fc;">' + it.quantity + '</span>' +
          '<button type="button" data-cart-inc="' + line + '" style="width:30px;height:30px;background:rgba(255,255,255,.02);border:none;color:#e9e2ff;cursor:pointer;">+</button></div>' +
          '<button type="button" data-cart-remove="' + line + '" style="background:none;border:none;color:rgba(233,226,255,.45);font-family:\'Jost\',sans-serif;font-size:11px;letter-spacing:.08em;cursor:pointer;">' + escapeHtml(S.remove || 'Remove') + '</button></div></div>' +
          '<div style="font-family:\'Jost\',sans-serif;font-size:14px;color:#b79bff;white-space:nowrap;">' + formatMoney(it.final_line_price) + '</div></div>';
      });
    }
    $$('[data-cart-body]').forEach(function (b) { b.innerHTML = html; });
    var foot = $('[data-cart-foot]');
    if (foot) {
      foot.innerHTML = cart.item_count ? (
        '<div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:14px;"><span style="font-family:\'Jost\',sans-serif;font-size:12px;letter-spacing:.16em;text-transform:uppercase;color:rgba(233,226,255,.6);">Subtotal</span><span style="font-family:\'Cormorant Garamond\',serif;font-size:22px;color:#f4f1fc;">' + formatMoney(cart.total_price) + '</span></div>' +
        '<a href="' + escapeHtml(routes.cart) + '" style="display:flex;align-items:center;justify-content:center;padding:16px;border-radius:var(--button-radius);background:linear-gradient(135deg,var(--color-accent),var(--color-accent-2));color:#fff;font-family:\'Jost\',sans-serif;font-weight:500;font-size:12px;letter-spacing:.24em;text-transform:uppercase;text-decoration:none;box-shadow:0 0 30px -6px rgba(140,90,255,.75);">' + escapeHtml(S.checkout || 'Checkout') + '</a>'
      ) : '';
    }
    updateBadge(cart.item_count);
  }
  function updateBadge(n) {
    $$('[data-cart-badge]').forEach(function (b) { b.textContent = n; b.style.display = n > 0 ? 'flex' : 'none'; });
  }
  function refreshCart() { return cartGet().then(renderCartBody).catch(function () {}); }

  // qty/remove inside cart body (drawer + page)
  document.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-cart-dec]'), inc = e.target.closest('[data-cart-inc]'), rm = e.target.closest('[data-cart-remove]');
    if (!dec && !inc && !rm) return;
    var row = e.target.closest('[data-cart-item]'); if (!row) return;
    var line = parseInt(row.getAttribute('data-line'), 10);
    var qtySpan = row.querySelector('span'); var cur = qtySpan ? parseInt(qtySpan.textContent, 10) || 1 : 1;
    var next = rm ? 0 : (inc ? cur + 1 : Math.max(0, cur - 1));
    cartChange(line, next).then(function (cart) { renderCartBody(cart); if (document.body.classList.contains('template-cart')) window.location.reload(); });
  });

  // card "add now" (single-variant products) — intercept the form submit
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-card-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var btn = form.querySelector('button');
    cartAdd(id, 1).then(function () { return refreshCart(); }).then(function () {
      if (btn) flyToCart(form.closest('.mp-card'));
      toast(S.addToCart ? 'Added' : 'Added');
    }).catch(function () { toast('Sold out'); });
  });

  /* ---------------- fly-to-cart ---------------- */
  function flyToCart(card) {
    try {
      var img = card && card.querySelector('img'); var bag = $('[data-open-cart]');
      if (!img || !bag) return;
      var r0 = img.getBoundingClientRect(), r1 = bag.getBoundingClientRect();
      var fly = img.cloneNode(true);
      fly.style.cssText = 'position:fixed;left:' + r0.left + 'px;top:' + r0.top + 'px;width:' + r0.width + 'px;height:' + r0.height + 'px;object-fit:cover;border-radius:10px;z-index:500;pointer-events:none;transition:all .7s cubic-bezier(.6,0,.2,1);opacity:.95;';
      document.body.appendChild(fly);
      requestAnimationFrame(function () {
        fly.style.left = r1.left + 'px'; fly.style.top = r1.top + 'px'; fly.style.width = '24px'; fly.style.height = '24px'; fly.style.opacity = '0.2';
      });
      setTimeout(function () { fly.remove(); }, 750);
    } catch (e) {}
  }

  /* ---------------- Quick Select popup ---------------- */
  var quick = { product: null, sel: {}, qty: 1 };
  function closeQuick() {
    var q = $('[data-quick]'); if (!q) return;
    var pn = q.querySelector('[data-quick-panel]'); if (pn) pn.style.transform = 'translateY(12px)';
    q.style.opacity = '0'; setTimeout(function () { q.style.visibility = 'hidden'; }, 340);
    quick.product = null; quick.sel = {}; quick.qty = 1;
  }
  function openQuick(handle) {
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (p) {
      quick.product = p; quick.sel = {}; quick.qty = 1;
      var q = $('[data-quick]'); if (!q) return;
      $('[data-quick-name]', q).textContent = p.title;
      $('[data-quick-price]', q).textContent = formatMoney(p.price);
      var imgWrap = $('[data-quick-img]', q);
      imgWrap.innerHTML = p.featured_image ? '<img src="' + escapeHtml(p.featured_image) + '" style="width:100%;height:100%;object-fit:cover;">' : '';
      renderQuickOptions(p, q);
      $('[data-quick-qty]', q).textContent = '1';
      var pn = q.querySelector('[data-quick-panel]');
      q.style.visibility = 'visible'; requestAnimationFrame(function () { q.style.opacity = '1'; if (pn) pn.style.transform = 'translateY(0)'; });
    }).catch(function () { toast('Unavailable'); });
  }
  function renderQuickOptions(p, q) {
    // p.options is array of names (Shopify /products.js). Map option1..3 -> groups.
    var groups = [ { el: $('[data-quick-opt1]', q), lbl: $('[data-quick-opt1-label]', q), pos: 1 }, { el: $('[data-quick-opt2]', q), lbl: $('[data-quick-opt2-label]', q), pos: 2 } ];
    var names = (p.options || []).map(function (o) { return (typeof o === 'string') ? o : o.name; });
    groups.forEach(function (g) {
      var name = names[g.pos - 1];
      if (!name) { if (g.el) g.el.innerHTML = ''; if (g.lbl) g.lbl.style.display = 'none'; return; }
      if (g.lbl) { g.lbl.style.display = ''; g.lbl.textContent = name; }
      var values = [];
      p.variants.forEach(function (v) { var val = v['option' + g.pos]; if (val && values.indexOf(val) < 0) values.push(val); });
      var isColor = /colou?r|لون/i.test(name);
      g.el.innerHTML = '';
      values.forEach(function (val) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('data-qopt', g.pos); b.setAttribute('data-qval', val);
        if (isColor) { b.title = val; b.style.cssText = 'width:34px;height:34px;border-radius:50%;background:' + (val.toLowerCase().split(' ').pop()) + ';border:2px solid rgba(255,255,255,.15);cursor:pointer;padding:0;'; }
        else { b.textContent = val; b.style.cssText = 'min-width:48px;padding:10px 14px;border-radius:9px;background:rgba(255,255,255,.02);border:1px solid rgba(160,120,255,.24);color:rgba(233,226,255,.8);font-family:Jost,sans-serif;font-size:13px;cursor:pointer;'; }
        b.addEventListener('click', function () {
          quick.sel[g.pos] = val;
          $$('[data-qopt="' + g.pos + '"]', g.el).forEach(function (o) { o.style.boxShadow = 'none'; if (!isColor) { o.style.background = 'rgba(255,255,255,.02)'; o.style.color = 'rgba(233,226,255,.8)'; } });
          if (isColor) b.style.boxShadow = '0 0 0 2px #160f30,0 0 0 4px #b79bff'; else { b.style.background = 'linear-gradient(135deg,#9a6bff,#6d4dff)'; b.style.color = '#fff'; }
        });
        g.el.appendChild(b);
      });
      // auto-select if only one value
      if (values.length === 1) { quick.sel[g.pos] = values[0]; }
    });
  }
  function quickResolveVariant() {
    var p = quick.product; if (!p) return null;
    var nOpts = (p.options || []).length;
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i]; var ok = true;
      for (var pos = 1; pos <= nOpts; pos++) { if (quick.sel[pos] && v['option' + pos] !== quick.sel[pos]) { ok = false; break; } if (!quick.sel[pos]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); openQuick(qa.getAttribute('data-product-handle')); return; }
    if (e.target.closest('[data-quick-inc]')) { quick.qty++; $('[data-quick-qty]').textContent = quick.qty; }
    if (e.target.closest('[data-quick-dec]')) { quick.qty = Math.max(1, quick.qty - 1); $('[data-quick-qty]').textContent = quick.qty; }
    if (e.target.closest('[data-quick-addbtn]')) {
      var p = quick.product; if (!p) return;
      var need = (p.options || []).length;
      var chosen = 0; for (var k in quick.sel) if (quick.sel[k]) chosen++;
      if (chosen < need) { var h = $('[data-quick-hint]'); if (h) { h.style.opacity = '1'; setTimeout(function () { h.style.opacity = '0'; }, 1800); } return; }
      var v = quickResolveVariant();
      if (!v || !v.available) { toast(S.soldOut || 'Sold Out'); return; }
      cartAdd(v.id, quick.qty).then(function () { return refreshCart(); }).then(function () { closeQuick(); openDrawer($('[data-cart-drawer]'), 'cart'); toast('Added'); });
    }
  });

  /* ---------------- Product page ---------------- */
  function initProduct() {
    var sec = $('[data-product-section]'); if (!sec) return;
    var variants = []; try { variants = JSON.parse($('[data-product-json]', sec).textContent); } catch (e) {}
    var sel = {}; var qty = 1;
    var priceEl = $('[data-price]', sec), compareEl = $('[data-compare]', sec), hint = $('[data-select-hint]', sec);
    var groups = $$('[data-option-group]', sec);
    var needCount = groups.length;

    function resolve() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var pos = 1; pos <= needCount; pos++) { if (!sel[pos] || (v.options[pos - 1] !== sel[pos])) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function update() {
      var v = (needCount === 0) ? variants[0] : resolve();
      if (v) {
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (compareEl) { if (v.compare_at_price > v.price) { compareEl.textContent = formatMoney(v.compare_at_price); compareEl.style.display = ''; } else { compareEl.style.display = 'none'; } }
      }
    }
    groups.forEach(function (g) {
      var pos = parseInt(g.getAttribute('data-option-position'), 10);
      $$('[data-option-value]', g).forEach(function (b) {
        var isColor = b.style.borderRadius === '50%';
        b.addEventListener('click', function () {
          sel[pos] = b.getAttribute('data-option-value');
          $$('[data-option-value]', g).forEach(function (o) {
            o.style.boxShadow = 'none';
            if (o.style.borderRadius !== '50%') { o.style.background = 'rgba(255,255,255,.02)'; o.style.color = 'rgba(233,226,255,.8)'; o.style.borderColor = 'rgba(160,120,255,.24)'; }
          });
          if (isColor) b.style.boxShadow = '0 0 0 2px #0c0820,0 0 0 4px #b79bff';
          else { b.style.background = 'linear-gradient(135deg,#9a6bff,#6d4dff)'; b.style.color = '#fff'; b.style.borderColor = 'transparent'; }
          update();
        });
      });
    });
    var qEl = $('[data-qty]', sec);
    $('[data-qty-inc]', sec) && $('[data-qty-inc]', sec).addEventListener('click', function () { qty++; qEl.textContent = qty; });
    $('[data-qty-dec]', sec) && $('[data-qty-dec]', sec).addEventListener('click', function () { qty = Math.max(1, qty - 1); qEl.textContent = qty; });

    function gate() {
      var chosen = 0; for (var k in sel) if (sel[k]) chosen++;
      if (chosen < needCount) { if (hint) { hint.style.opacity = '1'; setTimeout(function () { hint.style.opacity = '0'; }, 1800); } return null; }
      var v = resolve() || (needCount === 0 ? variants[0] : null);
      if (!v || !v.available) { toast(S.soldOut || 'Sold Out'); return null; }
      return v;
    }
    var addBtn = $('[data-add-cart]', sec), buyBtn = $('[data-buy-now]', sec);
    addBtn && addBtn.addEventListener('click', function () { var v = gate(); if (!v) return; cartAdd(v.id, qty).then(function () { return refreshCart(); }).then(function () { openDrawer($('[data-cart-drawer]'), 'cart'); toast('Added'); }); });
    buyBtn && buyBtn.addEventListener('click', function () { var v = gate(); if (!v) return; cartAdd(v.id, qty).then(function () { window.location.href = '/checkout'; }); });

    // gallery
    var imgs = $$('[data-gallery-img]', sec); var gi = 0;
    var dotsWrap = $('[data-gallery-dots]', sec);
    if (dotsWrap) imgs.forEach(function (_, i) { var d = document.createElement('span'); d.style.cssText = 'width:7px;height:7px;border-radius:50%;background:' + (i === 0 ? '#c9b3ff' : 'rgba(233,226,255,.35)') + ';transition:background .25s;'; dotsWrap.appendChild(d); });
    function show(i) { if (!imgs.length) return; gi = (i + imgs.length) % imgs.length; imgs.forEach(function (im, k) { im.style.opacity = k === gi ? '1' : '0'; }); if (dotsWrap) $$('span', dotsWrap).forEach(function (d, k) { d.style.background = k === gi ? '#c9b3ff' : 'rgba(233,226,255,.35)'; }); }
    $('[data-gallery-prev]', sec) && $('[data-gallery-prev]', sec).addEventListener('click', function () { show(gi - 1); });
    $('[data-gallery-next]', sec) && $('[data-gallery-next]', sec).addEventListener('click', function () { show(gi + 1); });
    var gal = $('[data-gallery]', sec), x0 = null;
    if (gal) { gal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true }); gal.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) show(gi + (dx < 0 ? 1 : -1)); }); }
    update();
  }

  /* ---------------- favorites (localStorage) ---------------- */
  function favSet() { try { return JSON.parse(localStorage.getItem('mp_favorites') || '{}'); } catch (e) { return {}; } }
  function paintFavs() { var f = favSet(); $$('[data-fav]').forEach(function (b) { var on = !!f[b.getAttribute('data-fav')]; var h = b.querySelector('[data-fav-heart]'); if (h) { h.setAttribute('fill', on ? '#ff6b9d' : 'none'); h.setAttribute('stroke', on ? '#ff6b9d' : '#e9e2ff'); } }); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fav]'); if (!b) return; e.preventDefault();
    var id = b.getAttribute('data-fav'); var f = favSet(); if (f[id]) delete f[id]; else f[id] = 1;
    try { localStorage.setItem('mp_favorites', JSON.stringify(f)); } catch (er) {}
    paintFavs();
  });

  /* ---------------- announcement marquee ---------------- */
  function initMarquee() {
    var bar = $('[data-annc]'); if (!bar) return;
    var track = $('[data-annc-track]', bar); if (!track) return;
    var speed = parseFloat(bar.getAttribute('data-speed')) || 45;
    var base = track.innerHTML; var guard = 0;
    while (track.scrollWidth < window.innerWidth * 2 && guard < 30) { track.innerHTML += base; guard++; }
    track.innerHTML = track.innerHTML + track.innerHTML;
    var half = track.scrollWidth / 2;
    var dur = half / speed;
    var id = 'mp-annc-kf';
    if (!document.getElementById(id)) { var st = document.createElement('style'); st.id = id; st.textContent = '@keyframes mpAnncScroll{from{transform:translate3d(0,0,0)}to{transform:translate3d(-50%,0,0)}}'; document.head.appendChild(st); }
    track.style.animation = 'mpAnncScroll ' + dur + 's linear infinite';
  }

  /* ---------------- predictive search ---------------- */
  function initSearch() {
    var input = $('[data-search-input]'); var results = $('[data-search-results]'); if (!input || !results) return;
    var timer;
    input.addEventListener('input', function () {
      var q = input.value.trim(); clearTimeout(timer);
      if (!q) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch((routes.predictive_search || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!items.length) { results.innerHTML = '<div style="padding:14px;color:rgba(233,226,255,.5);font-family:Jost,sans-serif;">' + escapeHtml(S.noResults || 'No products found.') + '</div>'; return; }
            results.innerHTML = items.map(function (p) {
              var img = (p.featured_image && p.featured_image.url) ? '<img src="' + escapeHtml(p.featured_image.url) + '" style="width:46px;height:69px;object-fit:cover;border-radius:8px;">' : '<div style="width:46px;height:69px;border-radius:8px;background:rgba(120,80,210,.2);"></div>';
              return '<a href="' + escapeHtml(p.url) + '" style="display:flex;align-items:center;gap:14px;padding:9px 8px;border-radius:12px;text-decoration:none;">' + img +
                '<div style="flex:1;"><div style="font-family:\'Cormorant Garamond\',serif;font-size:18px;color:#f4f1fc;">' + escapeHtml(p.title) + '</div>' +
                '<div style="font-family:Jost,sans-serif;font-size:13px;color:#b79bff;">' + (p.price ? formatMoney(p.price) : '') + '</div></div></a>';
            }).join('');
          }).catch(function () {});
      }, 180);
    });
  }

  /* ---------------- header scroll ---------------- */
  function initHeader() {
    var h = $('[data-header]'); if (!h) return;
    window.addEventListener('scroll', function () {
      var on = window.pageYOffset > 40;
      h.style.background = on ? 'rgba(9,6,20,.72)' : 'rgba(10,7,22,.55)';
    }, { passive: true });
  }

  /* ---------------- boot ---------------- */
  function boot() {
    initMarquee(); initSearch(); initHeader(); initProduct(); paintFavs(); refreshCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
